// Auto-generated skeleton for Address

export const Address: Api.Address = {
  id: 0,
  hp_id: null,
  street: '',
  country: '',
  city: '',
  zip: '',
  lat: null,
  lng: null,
  created: null,
  updated: null,
};

